import * as actionTypes from './actionTypes';

export const setPage = (page) => {
	return {
		type: actionTypes.SET_PAGE,
		page: page,
	};
};

export const setCategory = (category) => {
	return {
		type: actionTypes.SET_CATEGORY,
		category: category,
	};
};

export const addIngredient = (name) => {
	return {
		type: actionTypes.ADD_INGREDIENT,
		ingredientName: name,
	};
};
export const removeIngredient = (name) => {
	return {
		type: actionTypes.REMOVE_INGREDIENT,
		ingredientName: name,
	};
};
export const setIngredients = (ingredients) => {
	return {
		type: actionTypes.SET_INGREDIENTS,
		ingredients: ingredients,
	};
};

export const setFXPlaying = (effect) => {
	return {
		type: actionTypes.SET_FX_PLAYING,
		effect: effect,
	};
};

export const setMeme = (label, text) => {
	return {
		type: actionTypes.SET_MEME,
		label: label,
		text: text,
	};
};

export const setMessages = (direction, text) => {
	return {
		type: actionTypes.SET_MESSAGES,
		direction: direction,
		text: text,
	};
};

export const setDrawer = (bool) => {
	return {
		type: actionTypes.SET_DRAWER,
		bool: bool,
	};
};
